"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ToasterStyled = require("./Toaster-styled");

var _XIcon = _interopRequireDefault(require("calcite-ui-icons-react/XIcon"));

var _reactToastify = require("react-toastify");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// JSON
// CSS
var ToastContainer = function ToastContainer(_ref) {
  var other = _extends({}, _ref);

  var CloseButton = function CloseButton(_ref2) {
    var closeToast = _ref2.closeToast;
    return _react.default.createElement(_ToasterStyled.StyledCloseButton, {
      type: "button",
      iconButton: true,
      icon: _react.default.createElement(_XIcon.default, {
        size: 16
      }),
      onClick: closeToast
    });
  };

  return _react.default.createElement(_reactToastify.ToastContainer, _extends({
    closeButton: _react.default.createElement(CloseButton, null)
  }, other));
};

ToastContainer.propTypes = {
  /* Toggle default visibility of the progress bar in a Toaster. */
  showProgress: _propTypes.default.bool
};
ToastContainer.defaultProps = {};
ToastContainer.displayName = 'ToastContainer';
var _default = ToastContainer;
exports.default = _default;